// extracted by mini-css-extract-plugin
export default {"header":"common_header__6uA7Y","headerColumn":"common_headerColumn__bncEQ","on":"common_on__PTV-D","content":"common_content__woyMv"};